import { PromotionPage } from 'pageModules/PromotionPage';

export default PromotionPage;
